import { MAP_TYPES } from '@deck.gl/carto';

const HIGH_INJURY_NETWORK_SOURCE_ID = 'highInjuryNetworkSource';

const source = {
  id: HIGH_INJURY_NETWORK_SOURCE_ID,
  type: MAP_TYPES.QUERY,
  connection: 'bmpo-smartmetro-09142026',
  data: 'SELECT STREET_NAM as Street_Name, HRN_Score, CRASH_POIN as Crash_Point, EQ_POINTS_ as Eq_Points, PRI_SCEN2_, NUM_LANES as Number_Lanes, Speed, FUNCLASS, AADT, KSI_Crashes, geom FROM us-con-gcp-npr-0000424-011325.diamond.BSAP_High_Injury_Network;',
};

export default source;
